import * as _ from "lodash";
import * as $ from "jquery";
import {CommandType} from "./commandType";
import {Application} from "./application";

export interface ShortcutCommand {
    command: CommandType; 
    shortcut: string,
    commandArgs?: any
}

export default class ShortcutsManager {
    
    private shortcutCommand: Array<ShortcutCommand>;
    
    constructor(private app: Application) {
        this.shortcutCommand = [];
    }
    
    initShortcut(shortcut: string, commandType: CommandType, commandArgs?: any, additionalCommand?: any): void {
        this.shortcutCommand.push({command: commandType, shortcut: shortcut, commandArgs: commandArgs});
        this.bindCommand(document, shortcut, commandType, commandArgs, additionalCommand);
    }

    bindCommand(element: any, shortcut: string, commandType: CommandType, commandArgs?: any, additionalCommand?: any) {
        if(!element)
            return;
        
        $(element).bind('keydown', shortcut, (e) => {
            console.log('keydond', e);
            e.preventDefault();

            let command = this.app.commandsManager.find(commandType);

            if (!command)
                return;

            if (!command.canExecute())
                return;

            command.execute(commandArgs).then(() => {
                if(additionalCommand){
                    let secondCommand = this.app.commandsManager.find(additionalCommand);

                    if (!secondCommand)
                        return;

                    if (!secondCommand.canExecute())
                        return;

                    secondCommand.execute();
                }
            });

            return false;
        });
    }

    bindAction(shortcut: string, action: Function) {
        $(document).bind('keydown', shortcut, (e) => {
            console.log('keydond2', e);
            e.preventDefault();

            action();
        });
    }

  
    bind(shortcut: string, fn: () => void, element?: any) {
        let target = element ? element : document;
        
        $(target).bind('keydown', shortcut, (e) => {
            e.preventDefault();
            fn();
        });
    }

    unbind(fn: () => void) {
        $(document).unbind('keydown', fn);
        
    }

    unbindElement(element: any) {
        if(!element)
            return;

        $(element).unbind('keydown');
    }

    getShotcutByCommands(commands: CommandType[]): Array<ShortcutCommand> {
        let result: Array<ShortcutCommand> = [];
        
        if(!commands.length)
            return this.shortcutCommand;
        
        _.forEach(this.shortcutCommand, (shortcut: ShortcutCommand) => {
            let exist = _.find(commands, (command: CommandType) => {
                return command == shortcut.command;
            });
            
            if(exist)
                result.push(shortcut); 
        });

        return result;
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/shortcutsManager.ts